<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>
    <v-card
      width="450px">
      <v-card-title>Filtros</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-select
            v-model="filtros.idTipo"
            label="Tipo"
            item-value="id"
            item-text="descripcion"
            clearable
            :items="tiposDeObra">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.idPrograma"
            label="Programa"
            item-value="id"
            item-text="nombre"
            clearable
            :items="programas">
          </custom-select>
          <v-col
            cols="12">
            <v-switch v-model="filtros.incluirConContratos" label="Mostrar contratadas" hide-details
            inset></v-switch>
          </v-col>
          <v-col cols="12" class="my-2">
            <Select
              v-model="filtros.etiquetas"
              label="Etiquetas"
              placeholder="Seleccione las etiquetas"
              :items="getEtiquetas"
              deletable-chips
              multiple
              small-chips
              hide-details
              item-text="title"
              item-value="id">
            </Select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import ETIQUETAS from '@/graphql/querys/administracion/catalogos/etiquetas/etiquetas.gql';
import CustomSelect from '@/components/inputs/Select.vue';
import Select from '@/components/inputs/sinColumnas/Select.vue';

export default {
  name: 'FiltrosPlaneacion',
  components: {
    CustomSelect,
    Select,
  },
  props: {
    obras: {
      type: Array,
      required: false,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      tiposLicitacion: [
        { id: 1, texto: 'LICITACIÓN PÚBLICA' },
        { id: 2, texto: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
      ],
      tiposCaracter: [
        { id: 1, texto: 'NACIONAL' },
      ],
      tiposNormatividad: [
        { id: 1, texto: 'FEDERAL' },
        { id: 2, texto: 'ESTATAL' },
      ],
    };
  },
  apollo: {
    etiquetas: {
      query: ETIQUETAS,
      variables() {
        return {
          filtros: {
            modulo: 'OBRAS',
          },
        };
      },
    },
  },
  methods: {
  },
  computed: {
    tiposDeObra() {
      if (!this.obras || !Array.isArray(this.obras)) return [];
      const tiposDeObra = this.obras
        .map((obra) => obra.tipo)
        .filter((tipo) => tipo != null); // Filtrar elementos null/undefined
      return this.$removerDumplicadosArrayObj(tiposDeObra, 'id')
        .sort((a, b) => (`${a.descripcion}`).localeCompare(b.descripcion));
    },
    programas() {
      if (!this.obras || !Array.isArray(this.obras)) return [];
      const programas = this.obras
        .map((obra) => obra.programa)
        .filter((programa) => programa != null); // Filtrar elementos null/undefined
      return this.$removerDumplicadosArrayObj(programas, 'id')
        .sort((a, b) => (`${a.nombre}`).localeCompare(b.nombre));
    },
    getEtiquetas() {
      return this.etiquetas ? this.etiquetas.map((etiqueta) => ({
        title: etiqueta.nombre,
        subtitle: null,
        avatar: '',
        id: etiqueta.id,
      })) : [];
    },
  },
};
</script>

<style lang="scss">
</style>
